import config from '../config'

export const ON_DEMAND_APIS = {
  /* No Param */
  AREA_OF_INTERESTS: `${config.apiUrl}/api/area_of_interests`,
  GET_ABSTRACT: (abstractId) => `${config.apiUrl}/api/abstracts/${abstractId}`,

  /**
   * Params:
   * page=number (if blank, gets all abstracts)
   * page_length=number (default to 20)
   * area_of_interest=string
   */
  POSTERS: `${config.apiUrl}/api/poster`,
  ORALS: `${config.apiUrl}/api/oral`,

  /**
   * body payload
   * rating: number
   */
  RATE_ABSTRACT: (abstractId) => `${config.apiUrl}/api/abstracts/${abstractId}/abstract_ratings`,
}
